module.exports = __webpack_public_path__ + "img/MakerCCTV.936dd96c.svg";